import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-main" }
const _hoisted_2 = {
  key: 1,
  class: "main-view-container"
}

import { computed, onMounted, ref, watch } from 'vue'
import { fonts } from '@/static/fonts'
import MainView from '@/components/MainView.vue'
import NotEnoughMemory from '@/components/unsupported-pages/NotEnoughMemory.vue'
import IntroVideo from '@/components/onboarding/IntroVideo.vue'
import MainLoadingScreen from '@/components/MainLoadingScreen.vue'
import { swsplugin } from '@/auth/plugin'
import { app } from '@/main'
import { useApplicationStore } from '@/store/application-store'
import { useEndUserProfileStore } from '@/store/user-profile'
import { usePersistedStorage } from '@/composables/UsePersistedStorage'
import GtmHelper from '@/analytics/gtm-helper'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const onboardingVideoCompletedKey = 'onboarding.video.completed'
const applicationStore = useApplicationStore()
const endUserProfileStore = useEndUserProfileStore()
const { persistedStorage } = usePersistedStorage()
const isMainViewLoaded = computed(() => {
  return applicationStore.isPreviewCanvasLoaded && applicationStore.isActionMenuLoaded
})

const authenticateUser = () => {
  app.use(swsplugin)
}

const showIntro = ref(persistedStorage.getItem(onboardingVideoCompletedKey) !== 'true')
const onSkipIntro = () => {
  persistedStorage.setItem(onboardingVideoCompletedKey, 'true')
  showIntro.value = false
  authenticateUser()
}
// add userId watcher to enable GTM AFTER we fetch user id if GTM is enabled for this env
const isGtmEnabled = process.env.VUE_APP_GTM_ENABLED === 'true'
if (isGtmEnabled) {
  watch(() => endUserProfileStore.userId, () => {
    const userId = Number(endUserProfileStore.userId)
    const gtmHelper = GtmHelper.getInstance()

    // enable GTM only if
    // - User ID has been fetched
    // - GTM helper has not been enabled yet
    if (userId > 0 && !gtmHelper.isEnabled()) {
      // Enable GTM helper
      gtmHelper.enable()
      // Add userID to datalayer for GTM
      window.dataLayer?.push({
        'userId': userId
      })
    }
  })
}

onMounted(async () => {
  window.onbeforeunload = function () {
    /*
      This message can't be customized for the majority of new browsers,
      but we still have to return a message to make it work.
    */
    return isMainViewLoaded.value ? 'Changes that you made may not be saved.' : undefined
  }

  if (!showIntro.value) {
    authenticateUser()
  }
  // Wait for initially used fonts (Helvetica Neue) to be loaded first
  await document.fonts.ready

  // Load all custom fonts used by the canvas
  for (const font of fonts) {
    document.fonts.load(`1em ${font.name}`)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showIntro.value)
      ? (_openBlock(), _createBlock(IntroVideo, {
          key: 0,
          onSkipIntro: onSkipIntro
        }))
      : (_unref(endUserProfileStore).isLoggedIn && _unref(applicationStore).hasEnoughMemory)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(MainView, { isViewLoaded: _unref(isMainViewLoaded) }, null, 8, ["isViewLoaded"]),
            _createVNode(_Transition, { name: "app-main__fade-transition" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(MainLoadingScreen, { class: "main-view-container__loading-screen" }, null, 512), [
                  [_vShow, !_unref(isMainViewLoaded)]
                ])
              ]),
              _: 1
            })
          ]))
        : (!_unref(applicationStore).hasEnoughMemory)
          ? (_openBlock(), _createBlock(NotEnoughMemory, { key: 2 }))
          : _createCommentVNode("", true)
  ]))
}
}

})